module.exports = __webpack_public_path__ + "static/media/sm_facebook.38c7f3c6.svg";